import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/delivery.scss";

const formatPrice = (value) => `${siteConfig.currencySymbol}${Number(value).toFixed(2)}`;

function Delivery() {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main className="delivery">
      <div className="delivery__shell">
        <nav className="delivery__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" onClick={toTop}>Home</Link>
          <span aria-hidden="true">/</span>
          <span aria-current="page">Delivery</span>
        </nav>

        <header className="delivery__header">
          <p className="delivery__kicker">Customer care</p>
          <h1>Delivery information</h1>
          <p>Simple costs, useful estimates and an update when your parcel is on its way from a store operating in {siteConfig.operatingCountry}.</p>
        </header>

        <section className="delivery__highlight" aria-labelledby="delivery-highlight-title">
          <span className="delivery__highlight-icon" aria-hidden="true">→</span>
          <div>
            <h2 id="delivery-highlight-title">Tracked delivery is {formatPrice(siteConfig.shipping.standard)}</h2>
            <p>
              A fixed delivery charge applies to every order and is shown clearly in the cart and at checkout.
              We currently deliver only to the supported countries shown in the checkout country list. The business
              address is {siteConfig.contact.address}; it does not by itself identify a parcel&apos;s dispatch point or carrier route.
            </p>
          </div>
        </section>

        <div className="delivery__layout">
          <article className="delivery__card">
            <p className="delivery__eyebrow">01 / Dispatch</p>
            <h2>Preparing your order</h2>
            <p>
              In-stock orders are usually prepared within 1–2 working days. Orders placed at weekends
              or on public holidays observed by the operation in Germany begin processing on the next working day.
            </p>
            <p>
              During launches and seasonal peaks, preparation may take a little longer. We will show any
              known delay before checkout wherever possible.
            </p>
          </article>

          <article className="delivery__card">
            <p className="delivery__eyebrow">02 / On the road</p>
            <h2>Estimated delivery</h2>
            <p>
              Delivery timing varies by destination and normally ranges from 4–12 working days after dispatch.
              Remote areas and larger items may need additional time.
            </p>
            <p>
              Delivery dates are estimates rather than guarantees. A dispatch message will contain the
              tracking details available for the selected service.
            </p>
            <p>
              For EU consumer orders, goods should be delivered within 30 days unless another delivery time is
              agreed. Contact us if an agreed date or that period passes without delivery.
            </p>
          </article>

          <article className="delivery__card">
            <p className="delivery__eyebrow">03 / At your door</p>
            <h2>Address and receiving</h2>
            <p>
              Check the house number, postcode and contact details carefully before placing an order. Once
              packing begins, we may not be able to change the address.
            </p>
            <p>
              If a parcel arrives visibly damaged, photograph the outer packaging before opening it and
              contact us promptly so the issue can be documented.
            </p>
          </article>
        </div>

        <section className="delivery__notice" aria-labelledby="delivery-note-title">
          <div>
            <p className="delivery__eyebrow">Good to know</p>
            <h2 id="delivery-note-title">Track each order from dispatch.</h2>
          </div>
          <p>
            Tracking becomes available after the parcel is handed to the carrier. Customs, import requirements or
            local delivery conditions can occasionally extend cross-border estimates; any such requirements depend
            on the dispatch point and destination, not merely on the store&apos;s operating country.
          </p>
        </section>

        <section className="delivery__support" aria-labelledby="delivery-support-title">
          <div>
            <p className="delivery__eyebrow">Need a hand?</p>
            <h2 id="delivery-support-title">Ask us about your delivery.</h2>
            <p>Contact us during {siteConfig.contact.hours.toLowerCase()} and include your order number.</p>
          </div>
          <Link className="delivery__button" to="/contact" onClick={toTop}>
            Contact customer care <span aria-hidden="true">→</span>
          </Link>
        </section>
      </div>
    </main>
  );
}

export default Delivery;
